// Import model
import { SfMaterialAssignment } from '../models/SfMaterialAssignment';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfMaterialAssignment - handles JSON serialization and deserialization with type validation
 */
export class SfMaterialAssignmentSerializer {
  /**
   * Deserializes a JSON string into a SfMaterialAssignment instance
   */
  static deserialize(json: string): SfMaterialAssignment {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfMaterialAssignment instance
   */
  static fromObject(obj: any): SfMaterialAssignment {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfMaterialAssignment');
    }


    const instance: SfMaterialAssignment = {
      externalId: obj['externalId'] as string | undefined,
      isDeleted: obj['isDeleted'] as boolean | undefined,
      name: obj['name'] as string | undefined,
      proposalExternalId: obj['proposalExternalId'] as string | undefined,
      proposalExternalIdName: obj['proposalExternalId|Name'] as string | undefined,
      area: obj['area'] as number | undefined,
      perimeter: obj['perimeter'] as number | undefined,
      roomExternalId: obj['roomExternalId'] as string | undefined,
      roomExternalIdName: obj['roomExternalId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfMaterialAssignment instances
   */
  static deserializeArray(json: string): SfMaterialAssignment[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfMaterialAssignment instance to a JSON string
   */
  static serialize(instance: SfMaterialAssignment): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfMaterialAssignment instance to a plain object
   */
  static toObject(instance: SfMaterialAssignment): any {
    return {
      'externalId': instance.externalId,
      'isDeleted': instance.isDeleted,
      'name': instance.name,
      'proposalExternalId': instance.proposalExternalId,
      'proposalExternalId|Name': instance.proposalExternalIdName,
      'area': instance.area,
      'perimeter': instance.perimeter,
      'roomExternalId': instance.roomExternalId,
      'roomExternalId|Name': instance.roomExternalIdName,
    };
  }

  /**
   * Serializes an array of SfMaterialAssignment instances to a JSON string
   */
  static serializeArray(instances: SfMaterialAssignment[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
